export default __webpack_public_path__ + "static/force-usa_small-image_3-2b65670fa1d0d4942deaae222b8911ef.webp";